import PageTemplate from "./helpers/pagetemp";
import Sections from "./helpers/sections";

import LeaderSection from "./helpers/LeaderSection";
import Retired from "./helpers/RetiredSection";
import Discord from "./helpers/DiscordSection";

function MyMembers() {
    var sections = [
        {
            "title": "",
            "items": [<LeaderSection key="members-leaders" />]
        }, 
        {
            "title": "Join Our Discord!", 
            "items": [<Discord key="members-discord" />]
        }, 
        {
            "title": "Former Staff", 
            "items": [<Retired key="members-retired" />]
        }
    ];

    return (
        <PageTemplate id="members-page">
            <h1 className="my-5">Staff</h1>
            <Sections
                sections={sections}
                title_block={({ children }) => (
                    <h4 className="my-4" style={{ textAlign: 'center' }}>{children}</h4>
                )}
            />
        </PageTemplate>
    );
}

export default MyMembers;
